
export default {
  name: 'PodcastPlayer',
  props: {
    id: {
      type: String,
      default: 'large',
    },
    icons: {
      type: String,
      default: 'true',
    },
    script: {
      type:String,
      default: ''
    },
    buttons: {
      type:String,
      default: 'false'
    }
  },
  mounted() {
      const podcastScript = document.createElement('script')
      if(this.$props.script !== ''){
        podcastScript.setAttribute('src', encodeURI(this.$props.script))
      } else {
        podcastScript.setAttribute('src', 'https://www.buzzsprout.com/2049755.js?container_id=buzzsprout-player-'+this.$props.id+'&amp;player='+this.$props.id)
      }
      document.body.appendChild(podcastScript)
  },
}
